export interface TenantLike {
  id: string;
  role: string;
  /** SIM-3115: server-supplied. The portal reads this instead of deriving
   *  permissions from `role`, so a policy change is a server-only edit. */
  capabilities?: string[];
}

/**
 * Build a path prefixed with the tenant slug.
 * Returns path unchanged when slug is undefined.
 */
export function buildTenantPath(slug: string | undefined, path: string): string {
  if (!slug) return path;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `/${slug}${cleanPath}`;
}

/**
 * Derive the current role from the tenant list and selected ID.
 */
export function deriveTenantRole(tenants: TenantLike[], currentId: string | null): string | null {
  if (!currentId) return null;
  return tenants.find((t) => t.id === currentId)?.role ?? null;
}

/**
 * SIM-3115: the capabilities the server says this user holds in `currentId`.
 * Empty when no tenant is selected or the payload predates the field.
 */
export function deriveTenantCapabilities(
  tenants: TenantLike[],
  currentId: string | null,
): string[] {
  if (!currentId) return [];
  return tenants.find((t) => t.id === currentId)?.capabilities ?? [];
}

/**
 * Determine loading state for the tenant provider.
 */
export function isTenantLoading(authLoading: boolean, hasUser: boolean, fetched: boolean): boolean {
  return authLoading || (hasUser && !fetched);
}
